import React, { PureComponent } from 'react';
import { services } from '@comall-backend-builder/core';

/**
 * 订单改价审核
 */
export class ChangePriceCheckBtn extends PureComponent<any, any> {

    render() {
        const { row: { changeCode, status } } = this.props;
        const url = '/trade/changePrice/check/' + changeCode;
        
        return (
            status == 0 && (
                <a onClick={() => services.navigation.goto(url)} style={{marginRight: 10}}>
                    审核
                </a>
            )
        );
    }
}
